export default __webpack_public_path__ + "static/media/10009.57884183.png";